(function () {
  var PATHFINDER_HANDLE = 'filmmakers-career-guide-pathfinder-tier';
  var NORTH_STAR_HANDLE = 'filmmakers-career-guide-north-star-tier';

  var DROP_VARIANT_ID = 58124714049919;
  var DROP_SELLING_PLAN_ID = 715045798271;
  var DROP_DISCOUNT_CODE = 'MONTHLYDROP6FREE';

  var CALLS_VARIANT_ID = 58362396574079;
  var CALLS_SELLING_PLAN_ID = 715159798143;
  var CALLS_DISCOUNT_CODE = '1ON1CALLINCLUDED';

  var checking = false;
  var pendingPromise = null;

  var DROP_REDIRECT_KEY = 'ardyn_redirect_attempted_drop';
  var CALLS_REDIRECT_KEY = 'ardyn_redirect_attempted_calls';

  function cartHasHandle(cart, handle) {
    return cart.items.some(function (item) { return item.handle === handle; });
  }

  function findItemByVariant(cart, variantId) {
    return cart.items.find(function (item) { return item.variant_id === variantId; });
  }

  function cartHasVariant(cart, variantId) {
    return !!findItemByVariant(cart, variantId);
  }

  // cart.discount_codes is NOT a documented/reliable field on the raw Ajax
  // /cart.js response — it's inconsistently populated depending on theme
  // and context, and relying on it meant this check could silently always
  // report "not applied" even when a discount genuinely was. The properly
  // documented signal is each line item's own line_level_discount_allocations
  // (the same data already used to display/hide the discount name in the
  // cart template), so check that instead.
  function cartHasDiscount(cart, code) {
    var onLineItem = cart.items.some(function (item) {
      return (item.line_level_discount_allocations || []).some(function (a) {
        return a.discount_application && a.discount_application.title === code;
      });
    });
    if (onLineItem) return true;
    return (cart.cart_level_discount_applications || []).some(function (a) {
      return a.title === code;
    });
  }

  function addToCart(variantId, sellingPlanId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, selling_plan: sellingPlanId })
    });
  }

  function removeLineItem(lineKey) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    });
  }

  function clearDiscountCodes() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: '' })
    });
  }

  function tryRedirectOnce(guardKey, code) {
    if (sessionStorage.getItem(guardKey) === '1') return false;
    sessionStorage.setItem(guardKey, '1');
    var returnTo = window.location.pathname + window.location.search;
    window.location.href = '/discount/' + code + '?redirect=' + encodeURIComponent(returnTo);
    return true;
  }

  function checkAndBundle() {
    if (checking) return pendingPromise;
    checking = true;

    pendingPromise = fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hasPathfinder = cartHasHandle(cart, PATHFINDER_HANDLE);
        var hasNorthStar = cartHasHandle(cart, NORTH_STAR_HANDLE);
        var dropShouldBeDiscounted = hasPathfinder || hasNorthStar;
        var callsShouldBeDiscounted = hasNorthStar;

        var dropDiscountApplied = cartHasDiscount(cart, DROP_DISCOUNT_CODE);
        var callsDiscountApplied = cartHasDiscount(cart, CALLS_DISCOUNT_CODE);

        var dropNeedsRevert = dropDiscountApplied && !dropShouldBeDiscounted;
        var callsNeedsRevert = callsDiscountApplied && !callsShouldBeDiscounted;

        if (dropNeedsRevert || callsNeedsRevert) {
          sessionStorage.removeItem(DROP_REDIRECT_KEY);
          sessionStorage.removeItem(CALLS_REDIRECT_KEY);

          var removalChain = Promise.resolve();

          if (dropNeedsRevert) {
            var dropItem = findItemByVariant(cart, DROP_VARIANT_ID);
            if (dropItem) {
              removalChain = removalChain.then(function () { return removeLineItem(dropItem.key); });
            }
          }

          if (callsNeedsRevert) {
            var callsItem = findItemByVariant(cart, CALLS_VARIANT_ID);
            if (callsItem) {
              removalChain = removalChain.then(function () { return removeLineItem(callsItem.key); });
            }
          }

          return removalChain
            .then(clearDiscountCodes)
            .then(function () { return fetch('/cart.js'); })
            .then(function (r) { return r.json(); })
            .then(function (freshCart) {
              return proceedWithBundleAndDiscountChecks(freshCart, hasPathfinder, hasNorthStar);
            });
        }

        return proceedWithBundleAndDiscountChecks(cart, hasPathfinder, hasNorthStar);
      })
      .catch(function (err) {
        console.error('Ardyn bundle check failed', err);
        checking = false;
      });

    return pendingPromise;
  }

  function proceedWithBundleAndDiscountChecks(cart, hasPathfinder, hasNorthStar) {
    if (!hasPathfinder && !hasNorthStar) {
      checking = false;
      return;
    }

    var chain = Promise.resolve(cart);
    var addedAnything = false;

    chain = chain.then(function (currentCart) {
      if (!cartHasVariant(currentCart, DROP_VARIANT_ID)) {
        addedAnything = true;
        return addToCart(DROP_VARIANT_ID, DROP_SELLING_PLAN_ID)
          .then(function () { return fetch('/cart.js'); })
          .then(function (r) { return r.json(); });
      }
      return currentCart;
    });

    chain = chain.then(function (currentCart) {
      if (hasNorthStar && !cartHasVariant(currentCart, CALLS_VARIANT_ID)) {
        addedAnything = true;
        return addToCart(CALLS_VARIANT_ID, CALLS_SELLING_PLAN_ID)
          .then(function () { return fetch('/cart.js'); })
          .then(function (r) { return r.json(); });
      }
      return currentCart;
    });

    return chain.then(function (finalCart) {
      if (addedAnything) {
        document.dispatchEvent(new CustomEvent('ardyn:bundle-added'));
      }

      if (cartHasVariant(finalCart, DROP_VARIANT_ID) && !cartHasDiscount(finalCart, DROP_DISCOUNT_CODE)) {
        if (tryRedirectOnce(DROP_REDIRECT_KEY, DROP_DISCOUNT_CODE)) {
          checking = false;
          return;
        }
      }

      if (hasNorthStar && cartHasVariant(finalCart, CALLS_VARIANT_ID) && !cartHasDiscount(finalCart, CALLS_DISCOUNT_CODE)) {
        tryRedirectOnce(CALLS_REDIRECT_KEY, CALLS_DISCOUNT_CODE);
      }

      checking = false;
    });
  }

  document.addEventListener('DOMContentLoaded', checkAndBundle);

  if (window.PubSub && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    window.PubSub.subscribe(window.PUB_SUB_EVENTS.cartUpdate, checkAndBundle);
  }

  window.ArdynBundleCheck = checkAndBundle;
})();
